const digest = '68b896671dbb61d68b8b5f202ba0810fcd65059aba8f3f1551379fe84f75cbf8';
const css = `._carouselOverlay_yweq2_1{backdrop-filter:blur(6px) saturate(115%);-webkit-backdrop-filter:blur(6px) saturate(115%);background:linear-gradient(0deg,rgba(0,0,0,.62) 0,rgba(0,0,0,.36) 58%,hsla(0,0%,100%,.14));height:136px;mask-image:linear-gradient(0deg,#000 72%,transparent);-webkit-mask-image:linear-gradient(0deg,#000 72%,transparent)}@media (min-width:800px){._carouselOverlay_yweq2_1{height:96px}}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'carouselOverlay': '_carouselOverlay_yweq2_1' };
export const carouselOverlay = '_carouselOverlay_yweq2_1';
export { css, digest };